import { forwardRef } from "react";
import { useTranslation } from "react-i18next";

import Typography from "@material-ui/core/Typography";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import Slide from "@material-ui/core/Slide";

import DialogTitle from "@kimiya/dialogs/components/dialog-title";
import ContainedButton from "@kimiya/ui/button/contained-button.component";
import OutlinedButton from "@kimiya/ui/button/outlined-button.component";

import { makeStyles } from "@material-ui/core/styles";

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles((theme) => ({
    dialogText: {
        fontFamily: "Brown-Light",
        color: theme.palette.grey5.main,
        fontSize: theme.typography.pxToRem(16),
        letterSpacing: 0.44,
        marginBottom: theme.spacing(2)
    },
    dialogTextQuit: {
        fontFamily: "Brown-Bold",
        color: theme.palette.primary.main,
    },    
    dialogActions: {
        marginTop: theme.spacing(4),
    }
}));

const ConfirmActionDialog = ({ onRequestClose, callback, title, text, bottomComponent }) => {
    const classes = useStyles();
    const { t } = useTranslation();

    const closeDialog = () => {
        onRequestClose();
    };

    const confirmAction = () => {
        callback();
        onRequestClose();
    }

    return (
        <Dialog
            maxWidth={"sm"}
            fullWidth
            open
            TransitionComponent={Transition}
            onClose={closeDialog}
            >            
            <DialogTitle
                title={title}
                bottomComponent={bottomComponent}
                closeDialog={closeDialog}
            />
            <DialogContent className={classes.dialogContent}>
                <Typography className={classes.dialogText}>Sei sicuro di voler procedere?</Typography>
                {text && <Typography className={classes.dialogTextQuit}>{text}</Typography>}
            </DialogContent>
            <DialogActions className={classes.dialogActions}>
                <OutlinedButton
                    fullWidth
                    onClick={closeDialog}
                    variant="outlined"
                >
                    {t("Annulla")}
                </OutlinedButton>
                <ContainedButton                    
                    fullWidth
                    onClick={confirmAction}
                    color="secondary"
                    variant="contained"
                >
                    {t("Conferma")}
                </ContainedButton>
            </DialogActions>            
        </Dialog>
    );
};

export default ConfirmActionDialog;
